// init Isotope
$(document).ready(function () {
  $('.slider2').slick({
  prevArrow: '<button type="button" class="slick-prev">Previous</button>',
  nextArrow: '<button type="button" class="slick-next">Next</button>',
      rows: 1,
      dots: true,
      accessibility: true,
      speed: 300,
      slidesToShow: 4.5,
      slidesToScroll: 3,
      infinite: false,
      responsive: [
        {
            breakpoint: 0,
            settings: {
                rows: 2,
                slidesToScroll: 1,
                slidesToShow: 2,
                dots: true
            }
        },
        {
            breakpoint: 0,
            settings: {
                rows: 4,
                slidesPerRow: 1,
                slidesToScroll: 1,
                slidesToShow: 1,
                dots: true
            }
        }
    ]
  });

    var filtered = false;

    $('.filter-all').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.active').removeClass('active');
        $('.filter-all').addClass('active');
        filtered = false;
    });
  
    $('.js-filter[data-filter=".category-groen"]').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.slider2').slick('slickFilter','.category-groen');
        $('.active').removeClass('active');
        $('.js-filter[data-filter=".category-groen"]').addClass('active');
        filtered = true;
    });
  
    $('.js-filter[data-filter=".category-blaa"]').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.slider2').slick('slickFilter','.category-blaa');
        $('.active').removeClass('active');
        $('.js-filter[data-filter=".category-blaa"]').addClass('active');
        filtered = true;
    });
  
    $('.js-filter[data-filter=".category-roed"]').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.slider2').slick('slickFilter','.category-roed');
        $('.active').removeClass('active');
        $('.js-filter[data-filter=".category-roed"]').addClass('active');
        filtered = true;
    });
  
    $('.js-filter[data-filter=".category-sort"]').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.slider2').slick('slickFilter','.category-sort');
        $('.active').removeClass('active');
        $('.js-filter[data-filter=".category-sort"]').addClass('active');
        filtered = true;
    });
  
    $('.js-filter[data-filter=".category-graa"]').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.slider2').slick('slickFilter','.category-graa');
        $('.active').removeClass('active');
        $('.js-filter[data-filter=".category-graa"]').addClass('active');
        filtered = true;
    });

        $('.js-filter[data-filter=".category-brun"]').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.slider2').slick('slickFilter','.category-brun');
        $('.active').removeClass('active');
        $('.js-filter[data-filter=".category-brun"]').addClass('active');
        filtered = true;
    });

      $('.js-filter[data-filter=".category-ternet"]').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.slider2').slick('slickFilter','.category-ternet');
        $('.active').removeClass('active');
        $('.js-filter[data-filter=".category-ternet"]').addClass('active');
        filtered = true;
    });

   $('.js-filter[data-filter=".category-naalestribet"]').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.slider2').slick('slickFilter','.category-naalestribet');
        $('.active').removeClass('active');
        $('.js-filter[data-filter=".category-naalestribet"]').addClass('active');
        filtered = true;
    });

     $('.js-filter[data-filter=".category-ensfarvet"]').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.slider2').slick('slickFilter','.category-ensfarvet');
        $('.active').removeClass('active');
        $('.js-filter[data-filter=".category-ensfarvet"]').addClass('active');
        filtered = true;
    });

       $('.js-filter[data-filter=".category-sand"]').on('click', function () {
        $('.slider2').slick('slickUnfilter');
        $('.slider2').slick('slickFilter','.category-sand');
        $('.active').removeClass('active');
        $('.js-filter[data-filter=".category-sand"]').addClass('active');
        filtered = true;
    });
    
});

 // var $grid = $('.slider2').isotope({
 //    itemSelector: '.slide',
 //  });
 //  // filter functions
 //  var filterFns = {
 //    // show if number is greater than 50
 //    numberGreaterThan50: function() {
 //      var number = $(this).find('.number').text();
 //      return parseInt( number, 10 ) > 50;
 //    },
 //    // show if name ends with -ium
 //    ium: function() {
 //      var name = $(this).find('.name').text();
 //      return name.match( /ium$/ );
 //    }
 //  };
 //  // bind filter button click
 //  $('.filters-button-group').on( 'click', 'button', function() {
 //    var filterValue = $( this ).attr('data-filter');
 //    // use filterFn if matches value
 //    filterValue = filterFns[ filterValue ] || filterValue;
 //    $grid.isotope({ filter: filterValue });
 //  });
 //  // change is-checked class on buttons
 //  $('.button-group').each( function( i, buttonGroup ) {
 //    var $buttonGroup = $( buttonGroup );
 //    $buttonGroup.on( 'click', 'button', function() {
 //      $buttonGroup.find('.is-checked').removeClass('is-checked');
 //      $( this ).addClass('is-checked');
 //    });
 //  });

    // Add a click event for the price range filter button
$('.js-filter[data-filter=".category-price"]').on('click', function () {
    var minPrice = parseFloat($('#min-price').val()) || 2999;
    var maxPrice = parseFloat($('#max-price').val()) || Infinity;

    $('.slider2').slick('slickUnfilter');
    filterByPrice(minPrice, maxPrice);
    $('.active').removeClass('active');
    $(this).addClass('active');
    filtered = true;
});

// Function to filter slides by price range
function filterByPrice(minPrice, maxPrice) {
    $('.slider2 .slide').each(function () {
        var slidePrice = parseFloat($(this).data('price')) || 2999;
        if (slidePrice >= minPrice && slidePrice <= maxPrice) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
}



$('.js-filter[data-filter=".category-price"]').on('click', function () {
    // Update the price range slider values
    var minPrice = parseFloat($('#min-price').val()) || 2999;
    var maxPrice = parseFloat($('#max-price').val()) || 9999;
    
    // Filter slides based on the price range
    $('.slider2').slick('slickUnfilter');
    filterByPrice(minPrice, maxPrice);
    
    // Update the active class
    $('.active').removeClass('active');
    $(this).addClass('active');
    
    // Set the filtered flag
    filtered = true;
});


$(document).ready(function () {
  // Initialize the price range slider
  $("#price-range-slider").slider({
    range: true,
    min: 2999,
    max: 9999,
    values: [2999, 9999],
    slide: function (event, ui) {
      $("#min-price").val(ui.values[0]);
      $("#max-price").val(ui.values[1]);
    },
  });

  // Rest of your existing code...
});

  $('.slider2 .slide').on('click', function() {
      // Get the source attribute of the clicked image
      var imageUrl = $(this).find('img').attr('src');

      // Set the source of the big image box to the clicked image
      $('#big-image').attr('src', imageUrl);

      // Remove the border from all slides
      $('.slider2 .slide').removeClass('selected');

      // Add a border to the clicked slide
      $(this).addClass('selected');
    });

  // Function to update big image box with the first slide's image
  function updateBigImageOnLoad() {
    // Get the source attribute of the first slide's image
    var firstImageUrl = $('.slider2 .slide:first-child .imageunder').attr('src');

    // Set the source of the big image box to the first slide's image
    $('#big-image').attr('src', firstImageUrl);

    // Add a border to the first slide to indicate it's selected
    $('.slider2 .slide:first-child').addClass('selected');
  }

  // Call the function on page load
  updateBigImageOnLoad();


  // Function to update big image box with the second slide's image
  function updateBigImage(slide) {
    // Get the source attribute of the second slide's image in the clicked category
    var secondImageUrl = $(slide).find('img:nth-child(2)').attr('src');

    // Set the source of the big image box to the second slide's image
    $('#big-image').attr('src', secondImageUrl);

    // Remove the 'selected' class from all slides
    $('.slider2 .slide').removeClass('selected');

    // Add the 'selected' class to the clicked slide
    $(slide).addClass('selected');
  }

  // Call the function on page load
  updateBigImage($('.slider2 .slide.category-blaa:first-child'));

  // Click event handler for each slide
  $('.slider2 .slide').on('click', function() {
    // Call the updateBigImage function with the clicked slide
    updateBigImage(this);
  });



$('.slide').click(function() {

  // Sæt priser som før
  
  $('.priceboxes > div').css('display', 'block');

});


$('.slide').click(function() {

  // Sæt priser som før
   
  $('.priceboxes > div').css('display', 'block');
   
});

$('.slider').on('afterChange', function() {
  
  $('.priceboxes > div').css('display', 'none');
  
});

$('.slide').click(function() {

  var suitName = $(this).data('suit-name');
  var suitPrice = $(this).data('suit-price'); 
  var blazerPrice = $(this).data('blazer-price');
  var pantsPrice = $(this).data('pants-price');
  var vestPrice = $(this).data('vest-price');
 
  $('.nameofsuit').text(suitName); 
  $('.suitbox span').text(suitPrice);
  $('.blazerbox span').text(blazerPrice); 
  $('.bukserbox span').text(pantsPrice);
  $('.vestbox span').text(vestPrice);


});

$('.slider2 .slide').on('click', function() {

  // Remove border from all slides
  $('.slider2 .slide').removeClass('selected');
  
  // Add border to clicked slide
  $(this).addClass('selected');

});

